// Review: Have description on the usage of this Component and the usage and connectivity.
// This is the base class of all nested popups
// NestedPopupService is the base service class of all popup services and this 
// class instanciate relevent service when a popup component instanciate

import { Component, OnInit } from '@angular/core';
import { PopupResponse } from 'src/app/common/models/PopupResponse';
import { NestedPopupService } from 'src/app/services/UI/nested-popup.service';
import { PopupInputInfo } from 'src/app/common/models/PopupInputInfo';
import { OverlayService } from '../../../services/UI/overlay.service';

@Component({
    selector: 'app-popup-base',
    template: '',
    standalone: false
})
export class PopupBaseComponent implements OnInit {

  // Review : isPopupVisible
  public static OpenedCount: number = 0;
  public openedPopupsCount: number = 0;
  showPopup: boolean = false;
  startHiding: boolean = true;
  popupResponse: PopupResponse;
  nestedPopupServiceSubscription: any;
  showRoundedCorner: boolean = false;
  popupWidth: string;
  constructor(private nestedPopupService: NestedPopupService, private overlayService: OverlayService) {

  }

  ngOnInit() {
    this.show();
    console.log("Base popup Component ngOnInit()");
  }

  show() {
    console.log("Base popup Component ShowPopup()");

      this.nestedPopupServiceSubscription = this.nestedPopupService.onVisibilityChanged() // OnVisibilityChanged()
      .subscribe((obj: PopupInputInfo) => {

        PopupBaseComponent.OpenedCount = obj.visibility ? PopupBaseComponent.OpenedCount + 1 : PopupBaseComponent.OpenedCount - 1;
        this.showRoundedCorner = obj.level === 0; // if the current instance level is zero then showing the rounded corner
        this.startHiding = !obj.visibility;
        this.openedPopupsCount = obj.level; // this openedPopupsCount is already opened popups count. This need to be passed by the developer
        setTimeout(() => {
          this.showPopup = obj.visibility; // this showPopup value referes visible status of relevent popup component Ex: multimedia.component.html

          if (this.nestedPopupService.popupData.level === 0) {
              this.overlayService.showOverlay(obj.visibility);
          }
        }, 300); // 0.3s
      },
        err => { throw err; }
      );
  }

  isActivePopup() {
    return (this.openedPopupsCount + 1 === PopupBaseComponent.OpenedCount);
  }

  ngOnDestroy() {
    console.log("Unsubscribe Resources calls here");
    this.nestedPopupServiceSubscription.unsubscribe();
  }
}
